const styleSheet = () => ({
  width: '727px',
  '@media (max-width: 425px)': {
    width: '311px',
  },
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '20px',
    marginBottom: '20px',
  },
  flexPill: {
    maxWidth: '233px',
    color: '#223762',
    '@media (max-width: 425px)': {
      maxWidth: '200px',
    },
    display: 'inline-block',
    border: '1px solid grey',
    borderRadius: '32px',

    paddingLeft: '12px',
    paddingRight: '7px',
    paddingTop: '5px',
    paddingBottom: '5px',
    '&:hover': {
      backgroundColor: '#ECF3FD',
    },
    '&:focus': {
      border: 'solid 2px #085fe5',
    },
  },
  pill: {
    maxWidth: '200px',
    '@media (max-width: 425px)': {
      maxWidth: '170px',
    },
    display: 'inline-block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    position: 'relative',
    top: '2px',
    fontFamily: 'CircularStd, sans-serif',
  },
  close: {
    display: 'inline-block',
    cursor: 'pointer',
    position: 'relative',
    marginLeft: '5px',
    top: '2px',
  },
});
export default styleSheet;
